export function captureSplitTestGoal1() {
  if (!window.dataLayer[0].eligibleForSplitTest) { return; }

  const payload = JSON.stringify({ current_url: window.location.href, goal: "goal1" });
  const blob = new Blob([payload], { type: 'application/json' });

  navigator.sendBeacon("/split_test_campaigns/track_goal", blob);
}

export function captureSplitTestGoal2(email, url) {
  if (!window.dataLayer[0].eligibleForSplitTest) { return; }
  
  const current_url = url || window.location.href;
  const payload = JSON.stringify({ current_url, goal: "goal2", email });
  const blob = new Blob([payload], { type: 'application/json' });

  navigator.sendBeacon("/split_test_campaigns/track_goal", blob);
}

document.addEventListener('click', function(event) {
  const anchor = event.target.closest('a[href*="/landing/"], a[data-href*="/landing/"]');

  if (anchor && (anchor.href || anchor.dataset.href)) { 
    captureSplitTestGoal1(); 
  }
}, false);
